import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-dialog-external-users', {
    width: '500px',
    marginTop: '12px',
});

cssRule('.tb-dialog-external-users .tb-dialog-authentication-option', {
    marginBottom: '3px',
});

cssRule('.tb-dialog-external-users .tb-dialog-authentication-option-description', {
    marginLeft: '21px',
    marginBottom: '12px',
    width: '468px',
    fontSize: '11px',
});

cssRule('.tb-dialog-external-users .tb-select', {
    marginTop: '12px',
    display: 'inline-block',
    width: '100%',
});

cssRule('.tb-dialog-external-users .tb-dialog-external-users-prompt', {
    display: 'inline-block',
    marginLeft: '12px',
    width: '170px',
    verticalAlign: 'top',
    color: applyColor(DesignTokens.color.font.default.subtle, '#808080'),
    fontSize: '11px',
});

cssRule('.tb-dialog-external-users .tb-dialog-warnings-list', {
    marginTop: '12px',
    maxHeight: '200px',
    overflow: 'auto',
});

cssRule('.tb-dialog-external-users .tb-dialog-external-users-quota', {
    textAlign: 'right',
});

cssRule('.tb-dialog-external-users .tb-authentication-provider-selector', {
    marginBottom: '12px',
});

